module.exports = __webpack_public_path__ + "img/99.fc0d85fc.jpg";